/**
 * OAuth callback page - handles redirect from Cognito
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { Spinner } from '@/components/ui/Spinner';

export function CallbackPage() {
  const { isAuthenticated, isLoading, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Once auth check completes, redirect appropriately
    if (!isLoading) {
      if (isAuthenticated) {
        navigate('/', { replace: true });
      } else if (error) {
        navigate('/login', { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, error, navigate]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50">
      <Spinner size="lg" />
      <p className="mt-4 text-slate-600">Completing sign in…</p>
    </div>
  );
}
